import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged, map, take, tap } from "rxjs/operators";
import { Employee } from "@ui-components/models";
import { EmployeesDataService } from "./employees-data.service";

@Injectable({
    providedIn: 'root'
})
export class OrganizationChartService {

    private allEmployeesSubject = new BehaviorSubject<Employee[]>([]);
    allEmployees$: Observable<Employee[]> = this.allEmployeesSubject.asObservable();

    private expEmployeesSubject = new BehaviorSubject<number[]>([64]);
    expandedEmployees$: Observable<number[]> = this.expEmployeesSubject.asObservable();

    constructor(
        public employeesDataService: EmployeesDataService) {
        this.employeesDataService.employees$
            .pipe(
                distinctUntilChanged(),
                map(employees => {
                    const dohaIndex = employees.findIndex(emp => emp.ID === 88);
                    if (dohaIndex >= 0) {
                        const doha = { ...employees[dohaIndex] }
                        employees.splice(dohaIndex, 1);
                        employees.unshift(doha);
                    }
                    return employees as Employee[]
                }),
                tap((employees: Employee[]) => this.allEmployeesSubject.next(employees))
            )
            .subscribe();
    }

    isHaveChildren(id: number | string) {
        if (!id) { return; }
        let emps: Employee[];
        this.allEmployees$.pipe(take(1)).subscribe(res => emps = res);

        const totalChildren = emps.filter(e => +e.MANAGER_ID === +id);
        return totalChildren.length > 0 ? true : false;
    }

    toggleEmployee(event, id: number | string) {
        let emps: Employee[];
        let expandedEmployees: number[];

        this.allEmployees$.pipe(take(1)).subscribe(res => emps = res);
        this.expandedEmployees$.pipe(take(1)).subscribe(res => expandedEmployees = res);

        const targetEmp = emps.find(e => e.ID === id);
        const targetEmpChildren = emps.filter(e => e.MANAGER_ID === id);
        const targetEmpParent = emps.find(e => e.ID === targetEmp.MANAGER_ID);
        const expEmpIndex = expandedEmployees.findIndex(x => x === targetEmp.ID);


        if(expEmpIndex >= 0 && targetEmpParent){
            this.buildHirarchyTree(targetEmpParent, []);
        }
        else if(expEmpIndex >= 0 && !targetEmpParent){
            this.expEmployeesSubject.next([]);
        }
        else {
            if(targetEmpChildren.length > 0){
                this.buildHirarchyTree(targetEmp, []);
            }
        }

        event.stopPropagation();
    }

    buildHirarchyTree(employee: Employee, arr: number[]) {
        arr.push(employee.ID);

        if (!employee.MANAGER_ID) {
            this.expEmployeesSubject.next(arr);
        }
        else {
            let emps: Employee[];
            this.allEmployees$.pipe(take(1)).subscribe(res => emps = res);

            const targetEmp = emps.find(e => e.ID === employee.MANAGER_ID);
            this.buildHirarchyTree(targetEmp, arr);
        }
    }
}